import { render, staticRenderFns } from "./review-component.vue?vue&type=template&id=6d2bde90"
import script from "./review-component.vue?vue&type=script&lang=js"
export * from "./review-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports